import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines, Eyebrow } from "./motion";
import { scrollToId } from "../lib/scroll";
import { useLang } from "../i18n";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["-4%", "18%"]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="bg-[#F7F5F0] py-24 md:py-40">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-5 relative h-[520px] md:h-[680px] lg:sticky lg:top-28 self-start">
          <motion.div style={{ y: y1 }} className="absolute left-0 top-0 w-[78%] h-[82%] arch overflow-hidden spotlight">
            <img src="/img/casas/coracao2/17.jpg" alt="Fachada branca da Casa Coração Alentejano" className="w-full h-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-[48%] h-[44%] overflow-hidden rounded-sm border-[6px] border-[#F7F5F0] shadow-2xl">
            <img src="/img/casas/marias2/1.jpg" alt="Fachada da Casa Das Maria's" className="w-full h-full object-cover" />
          </motion.div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 flex flex-col">
          <Eyebrow>{a.eyebrow}</Eyebrow>
          <MaskedLines
            lines={[a.lines[0], <em key="e" className="italic text-[#B85D3B]">{a.lines[1]}</em>]}
            className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#1C1D1A] mt-6"
          />
          <Reveal delay={0.2}>
            <div data-testid="about-story-text" className="mt-10 space-y-5 text-[#4A4C45] text-base leading-relaxed">
              {a.story.map((p, i) => <p key={i}>{p}</p>)}
            </div>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-3 gap-8 border-t border-[#E2DDD5] pt-10">
            {a.values.map(([title, d], i) => {
              const n = `0${i + 1}`;
              return (
              <Reveal key={n} delay={0.1 * i} data-testid={`about-value-${n}`}>
                <span className="font-mono text-xs text-[#B85D3B]">{n}</span>
                <h3 className="font-display text-2xl mt-2 text-[#1C1D1A]">{title}</h3>
                <p className="text-sm text-[#5C5E56] mt-2 leading-relaxed">{d}</p>
              </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.3}>
            <button data-testid="about-cta" onClick={() => scrollToId("houses")} className="group mt-12 inline-flex items-center gap-3 text-[#1C1D1A] text-sm tracking-wide">
              <span className="link-underline">{a.cta}</span>
              <span className="w-10 h-10 rounded-full border border-[#1C1D1A] flex items-center justify-center group-hover:bg-[#1C1D1A] group-hover:text-[#F7F5F0] transition-colors">
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
              </span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
